import './index.scss'
import { Controller as BaseController } from 'stimulus'
import Rails from '@rails/ujs'

export class Controller extends BaseController {
  static targets = ['triggerButton']
  static values = { elementId: String, url: String }

  setPriorityValue(ev) {
    this.disableTriggerButton()

    Rails.ajax({
      type: 'POST',
      url: this.urlValue,
      dataType: 'json',
      data: $.param({
        name: ev.currentTarget.dataset.value,
        value: ev.currentTarget.dataset.index,
        priority_element_id: this.elementIdValue
      })
    })
  }

  disableTriggerButton() {
    const disableWith = this.triggerButtonTarget.getAttribute('data-disable-with')

    this.triggerButtonTarget.disabled = true
    this.triggerButtonTarget.querySelector('label').innerHTML = disableWith
  }
}
